export default "__VITE_ASSET__D7sa9HlU__"